import React, {useEffect, useState} from 'react';
import {Facility} from "types/Facility";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useOperator} from "context/OperatorContext";

type Props = {
    facility: Facility | null
    show: boolean
    onDelete?: (facility: Facility) => any
    onDeleteFail?: (facility: Facility, error: unknown) => any
    onCancel?: () => any
}

function DeleteFacility(props: Props) {
    const {termFor} = useOperator()
    const {facility, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(facility?.name || `this ${termFor('facility')}`);
    const {mutateAsync: deleteFacility} = useMutation(ngage.facilities.destroy)

    useEffect(() => {
        if(facility) setName(facility.name)
    }, [facility]);

    async function handleDeleteFacility() {
        if (facility) {
            try {
                await deleteFacility(facility.id)
                await invalidate('facilities.all')

                if (onDelete) onDelete(facility)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(facility, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={`Delete ${termFor('Facility')}`}
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteFacility}
            onCancel={handleCancel}
        />
    );
}

export default DeleteFacility;